/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import styles from './MiddleColumnSkeleton.module.scss';
import { Divider, Skeleton } from '@az/starc-ui';
import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export default function MiddleColumnSkeletonBottom() {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  return (
    <div className={styles.bottomContainer}>
      <FlexGrid gap={4} flexDirection="column">
        {/** Skeletal for brand section */}
        <FlexGrid gap={4} flexDirection="column" className={styles.brandSelector}>
          {isDesktop && <Divider className={styles.firstDivider} />}
          <FlexGrid gap={2} flexDirection="column">
            <Skeleton className={styles.brand} />
            <FlexGrid gap={3} className={styles.brands}>
              <Skeleton className={styles.selectableBrand} />
              <Skeleton className={styles.selectableBrand} />
              <Skeleton className={styles.selectableBrand} />
              <Skeleton className={styles.selectableBrand} />
            </FlexGrid>
          </FlexGrid>
        </FlexGrid>
        <Divider className={styles.secondDivider} />
        {/** Skeletal for specifications section */}
        <FlexGrid flexDirection="column" gap={2}>
          <FlexGrid justifyContent="space-between">
            <Skeleton className={styles.specs} />
            <Skeleton className={styles.viewAll} />
          </FlexGrid>
          <FlexGrid className={styles.grid} gap={2}>
            <Skeleton />
            <Skeleton />
          </FlexGrid>
          <FlexGrid className={styles.grid} gap={2}>
            <Skeleton />
            <Skeleton />
          </FlexGrid>
        </FlexGrid>
        <Divider />
        {/** Skeletal for features section */}
        <FlexGrid gap={1} flexDirection="column">
          <Skeleton className={styles.featureHeading} />
          <Skeleton className={styles.feature} />
          <Skeleton className={styles.middleFeature} />
          <Skeleton className={styles.feature} />
        </FlexGrid>
        <Divider />
        {/** Skeletal for notes section */}
        <FlexGrid gap={1} flexDirection="column">
          <Skeleton className={styles.noteHeading} />
          <Skeleton className={styles.note} />
          <Skeleton className={styles.noteSecondLine} />
        </FlexGrid>
      </FlexGrid>
    </div>
  );
}
